import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getSpecialInstructionsList } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
const UseFetchSpecialInstructions = (page, pageSize, q, type) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["getSpecialInstructionsList", page, pageSize, q, type],
        queryFn: () => getSpecialInstructionsList(page, pageSize, q, type),
        enabled: !!page || !!pageSize || !!q,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchSpecialInstructions;
